import {Action} from '@ngrx/store';
import {Deserialize, Serialize} from 'cerialize';
import {GetUsersAction} from '../actions/users/get-users-action';
import {GetUsersErrorAction} from '../actions/users/get-users-error-action';
import {GetUsersSuccessAction} from '../actions/users/get-users-success-action';
import {UpdateUsersAction} from '../actions/users/update-users-action';
import {UpdateUsersErrorAction} from '../actions/users/update-users-error-action';
import {UsersState} from '../states/users-state';

const initialState = new UsersState();

export function UsersReducer(serializedState: any = Serialize(initialState), action: Action): any {
  const state: UsersState = Deserialize(serializedState, UsersState);

  switch (action.type) {
    case GetUsersAction.type:
      state.ready = false;
      state.error = null;
      break;

    case GetUsersSuccessAction.type:
      state.ready = true;
      state.users = (<GetUsersSuccessAction>action).users;
      state.error = null;
      break;

    case GetUsersErrorAction.type:
      state.ready = true;
      state.error = (<GetUsersErrorAction>action).error;
      break;

    case UpdateUsersAction.type:
      state.ready = false;
      state.error = null;
      break;

    case UpdateUsersErrorAction.type:
      state.ready = true;
      state.error = (<UpdateUsersErrorAction>action).error;
      break;

    default:
      return serializedState;
  }

  return Serialize(state);
}
